import React, { useEffect, useRef } from "react";
import {
  TableCell,
  TableRow,
  TableCellLayout,
  PopoverTrigger,
  Popover,
  PopoverSurface,
} from "@fluentui/react-components";
import { useState } from "react";
import { utcToLocalDateString } from "../../../../../utils/systemSettings";
import {
  MeatBallsMenuIcon,
  DocumentPDFSvg,
} from "../../../../../modules/default-svg";
import PDF from "../../../../../assets/svg/DocumentPDF.svg";
import moment from "moment";

const MeetingRegisteryRow = (props) => {
  const { sortingCriteria, data, handleModal, menu, sortRegisteryRequest } =
    props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [setting] = useState(settings);
  const [sortedData, setSortedData] = useState([]);
  const [popoverOpen, setPopoverOpen] = useState({});
  const popoverRef = useRef(null);

  useEffect(() => {
    if (sortingCriteria.column !== null) {
      var startDate = moment().startOf("month").format("YYYY-MM-DD");
      var endDate = moment().endOf("month").format("YYYY-MM-DD");
      sortRegisteryRequest({
        page: 1,
        size: 10,
        start: startDate,
        end: endDate,
        orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
      });
    }
  }, [sortingCriteria]);

  useEffect(() => {
    if (typeof data != "string") {
      setSortedData(data);
    }
  }, [data]);

  useEffect(() => {
    if (menu.props.closePopover) {
      setPopoverOpen(null);
    }
  }, [menu.props.closePopover]);

  const handlePopoverOpen = (rowId) => {
    setPopoverOpen(rowId);
  };

  const handleClickOutside = (event) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target) &&
      event.target?.innerText !== "Remind me" &&
      event.target?.innerText !== "Preview" &&
      event.target?.innerText !== "Download"
    ) {
      if (popoverOpen) {
        handlePopoverOpen(null);
      }
    }
  };

  const handleScroll = (e) => {
    handlePopoverOpen(null);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("wheel", handleScroll);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("wheel", handleScroll);
    };
  }, []);

  return sortedData.map((item) => (
    <TableRow key={item.id} ref={popoverRef}>
      <TableCell tabIndex={0} role="gridcell">
        <div className="d-flex justify-content-between inputWidth">
          <div className="d-flex justify-content-between inputWidth">
            <TableCellLayout className="text-truncate">
              <span className="me-2">
                <DocumentPDFSvg />
              </span>
              <span>{item.name}</span>
            </TableCellLayout>
          </div>
          <div className="flag">
            <Popover
              {...props}
              open={popoverOpen === item.id}
              onOpenChange={(isOpen) => isOpen && handlePopoverOpen(item.id)}
              positioning="below-start"
            >
              <PopoverTrigger disableButtonEnhancement>
                <TableCellLayout
                  media={<MeatBallsMenuIcon />}
                  onClick={() => handleModal(item)}
                />
              </PopoverTrigger>
              <PopoverSurface tabIndex={-1} className="listingPopoverWrapper">
                {menu}
              </PopoverSurface>
            </Popover>
          </div>
        </div>
      </TableCell>
      <TableCell>{utcToLocalDateString(setting, item.startTime)}</TableCell>
      <TableCell>{item.owner.name}</TableCell>
    </TableRow>
  ));
};

export default MeetingRegisteryRow;
